import { render, staticRenderFns } from "./cart-header.vue?vue&type=template&id=0e44bba3"
import script from "./cart-header.vue?vue&type=script&lang=js"
export * from "./cart-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports